import { FormattedMessage } from 'react-intl'

import { IconDocumentCheck, IconDocumentWrite, IconUserWait } from 'components/Icons'

import { Step } from './Step'

type Props = {
	completedStep: 'signup' | 'budget'
}

export const SingleApplicant = ({ completedStep }: Props) => (
	<>
		<Step
			icon={<IconDocumentWrite />}
			title={
				<FormattedMessage id='flow.nextSteps.singleApplicant.step1' defaultMessage='Bank details have been submitted' />
			}
			isCompleted
		/>
		<Step
			icon={<IconDocumentCheck />}
			title={
				<FormattedMessage
					id='flow.nextSteps.singleApplicant.step2'
					defaultMessage='Budget has been finalized and submitted'
				/>
			}
			isCompleted={completedStep === 'budget'}
		/>
		<Step
			icon={<IconUserWait />}
			title={
				<FormattedMessage
					id='flow.nextSteps.singleApplicant.step3'
					defaultMessage='Nordea will process your application once all information has been received.'
				/>
			}
		/>
	</>
)
